import { useDispatch, useSelector } from "react-redux";
import { get_po_backlog_state } from "../../../../../redux/po_backlog/backlog.selector";
import { MenuItem, Select } from "@mui/material";
import { handle_backlog_status_remarks_update } from "../../../../../redux/po_backlog/backlog.action";

export const BacklogTableStatusSelectNew = ({ key_name, excel_row, select_status, select_options, is_disabled = false }) => {
  const backlog = useSelector(get_po_backlog_state);
  const dispatch = useDispatch();
  return (
    // <FormControl sx={{
    //   width: "100%"
    // }}>
    //   <InputLabel
    //     id={`${key_name}-${excel_row.id}-label`}
    //   >Status</InputLabel>
    // </FormControl>
    <Select
      sx={{
        width: "100%"
      }}
      labelId={`${key_name}-${excel_row.id}-label`}
      id={`${key_name}-${excel_row.id}`}
      value={select_status}
      // label="Status"
      disabled={is_disabled}
      // size='small'
      onChange={(e) => {
        // set_select_status(e.target.value);
        dispatch(handle_backlog_status_remarks_update(backlog, e, excel_row, excel_row.id, key_name));
      }}
    >
      {
        select_options.map(({ value, label }, index) =>
          <MenuItem key={`${excel_row.id}-${value}-${label}-${key_name}-${index}`} value={value} >{label}</MenuItem>
        )
      }
    </Select>
  );
};